import Panel from '@maison/components/common/Panel.vue';
import { get } from 'lodash-es';
import { closePanel } from '@phoenix/helpers/panel-helper';

export default {
  components: { Panel },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  methods: {
    getPanelProps(event) {
      return event instanceof Event ? JSON.parse(get(event, 'target.dataset.panelProps', '{}')) : event;
    },

    close() {
      closePanel(this.id);
    },
  },
};
